import { normalizeFileUrl, getAvatarUrl, isAbsoluteUrl, isImageUrl, getFileNameFromUrl } from '@/utils/fileUtils';

export default {
  methods: {
    /**
     * Нормализует URL файла для отображения
     * @param {string} fileUrl - URL файла
     * @returns {string}
     */
    normalizeFileUrl(fileUrl) {
      return normalizeFileUrl(fileUrl, this.$api_url || '');
    },

    /**
     * Получает правильный URL аватара
     * @param {string} avatarUrl - URL аватара
     * @returns {string}
     */
    getAvatarUrl(avatarUrl) {
      return getAvatarUrl(avatarUrl, this.$api_url || '');
    },

    /**
     * Проверяет, является ли URL абсолютным
     * @param {string} url
     * @returns {boolean}
     */
    isAbsoluteUrl(url) {
      return isAbsoluteUrl(url);
    },

    /**
     * Проверяет, является ли URL изображением
     * @param {string} url
     * @returns {boolean}
     */
    isImageUrl(url) {
      return isImageUrl(url);
    },

    /**
     * Извлекает имя файла из URL
     * @param {string} url
     * @returns {string}
     */
    getFileNameFromUrl(url) {
      return getFileNameFromUrl(url);
    }
  }
};